import { render, staticRenderFns } from "./ClientsTableItem.vue?vue&type=template&id=37443a74&scoped=true&"
import script from "./ClientsTableItem.vue?vue&type=script&lang=js&"
export * from "./ClientsTableItem.vue?vue&type=script&lang=js&"
import style0 from "./ClientsTableItem.vue?vue&type=style&index=0&id=37443a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37443a74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
